import type { AuthorityEvent } from "./table-controller";

export interface TributeReveal {
  readonly key: string;
  readonly kind: "offer" | "return";
  readonly fromSeat: number;
  readonly toSeat: number | null;
  readonly cardId: string;
  readonly tributeKind: "single" | "double" | "inner";
}

function seat(value: unknown): number | null {
  return typeof value === "number" && Number.isInteger(value) ? value : null;
}

function tributeKind(value: unknown): TributeReveal["tributeKind"] | null {
  return value === "single" || value === "double" || value === "inner"
    ? value
    : null;
}

export function reduceTributeReveals(
  current: readonly TributeReveal[],
  event: AuthorityEvent,
): readonly TributeReveal[] {
  if (event.type === "CARDS_DEALT" || event.type === "ANTI_TRIBUTE") return [];
  if (
    event.type !== "TRIBUTE_OFFERED" &&
    event.type !== "TRIBUTE_RECEIVED" &&
    event.type !== "TRIBUTE_RETURNED"
  )
    return current;

  const fromSeat = seat(event.payload.from);
  const toSeat = seat(event.payload.to);
  const cardId = event.payload.cardId;
  const kind = tributeKind(event.payload.tributeKind);
  if (fromSeat === null || typeof cardId !== "string" || kind === null)
    return current;

  if (event.type === "TRIBUTE_RECEIVED") {
    const withoutPendingOffer = current.filter(
      (item) =>
        !(
          item.kind === "offer" &&
          item.fromSeat === fromSeat &&
          item.cardId === cardId
        ),
    );
    return [
      ...withoutPendingOffer,
      {
        key: `offer-${event.seq}`,
        kind: "offer" as const,
        fromSeat,
        toSeat,
        cardId,
        tributeKind: kind,
      },
    ];
  }

  const reveal: TributeReveal = {
    key: `${event.type === "TRIBUTE_RETURNED" ? "return" : "offer"}-${event.seq}`,
    kind: event.type === "TRIBUTE_RETURNED" ? "return" : "offer",
    fromSeat,
    toSeat,
    cardId,
    tributeKind: kind,
  };
  return [...current, reveal].slice(-4);
}
